import Router from 'next/router';
import { useCallback } from 'react';

import { reportErrorToBugsnag } from '@air/utils-error';

import { Routes } from '~/constants/routes';
import { useGoToPrivateBoardPage } from '~/hooks/useGoToPrivateBoardPage';
import { type LocationBoard } from '~/store/router/types';

export const useWorkspaceImportsOpenDestination = () => {
  const { goToBoardPage } = useGoToPrivateBoardPage();

  const openDestination = useCallback(
    (board: LocationBoard) => {
      const navigation = board.id
        ? goToBoardPage({
            board,
            trackLocation: 'import-popover',
          })
        : Router.push(Routes.media.all);

      navigation.catch((error: unknown) => {
        reportErrorToBugsnag({
          context: 'Failed to open import destination',
          error,
        });
      });
    },
    [goToBoardPage],
  );

  return { openDestination };
};
